import { useMutation, useQueryClient } from 'react-query';
import { resendSportButtonEventAsync, resendSportButtonEventsBulkAsync } from '../../index';
import { SPORT_BUTTON_EVENTS_KEYS } from '../useQuery';

export const useResendSportButtonEventAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(resendSportButtonEventAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SPORT_BUTTON_EVENTS_KEYS.ALL]);
    },
  });
};

export const useResendSportButtonEventsBulkAsync = () => {
  const queryClient = useQueryClient();

  return useMutation(resendSportButtonEventsBulkAsync, {
    onSuccess: () => {
      queryClient.invalidateQueries([SPORT_BUTTON_EVENTS_KEYS.ALL]);
    },
  });
};
